module.exports = __webpack_public_path__ + "img/shopping-bag.9bd01aee.svg";